import { Reveal } from "./Reveal";
import { Compass, Briefcase, Map, Truck, Route } from "lucide-react";

const audiences = [
  {
    icon: Compass,
    title: "Entrepreneurs",
    text: "You want to build a real operating business in the transportation industry.",
  },
  {
    icon: Briefcase,
    title: "Business Owners",
    text: "You're looking to expand into trucking without personally building an operations department from scratch.",
  },
  {
    icon: Map,
    title: "First-Time Trucking Owners",
    text: "You see the opportunity in trucking but don't have experience running a motor carrier.",
  },
  {
    icon: Truck,
    title: "Existing Carrier Owners",
    text: "You already own trucks or authority but need stronger operating systems and management.",
  },
  {
    icon: Route,
    title: "Drivers Ready To Own",
    text: "You already know trucking from behind the wheel and are ready to start building the company itself.",
  },
];

export const Audience = () => {
  return (
    <section id="who" data-testid="audience-section" className="bg-[#0A0A0A] py-24 md:py-32 border-y border-neutral-800">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <Reveal>
          <p className="font-display text-sm font-semibold uppercase tracking-[0.3em] text-orange-500 mb-6" data-testid="audience-eyebrow">
            Who This Is For
          </p>
          <h2
            className="font-display text-4xl md:text-5xl font-bold uppercase tracking-tight text-white"
            data-testid="audience-headline"
          >
            Who Should Own A Trucking Company?
          </h2>
        </Reveal>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="audience-grid">
          {audiences.map((a, i) => (
            <Reveal key={a.title} delay={0.07 * i}>
              <div
                data-testid={`audience-card-${i}`}
                className="h-full border border-neutral-800 bg-[#121212] p-8 transition-all duration-200 hover:-translate-y-1 hover:border-orange-500/70"
              >
                <a.icon size={30} className="text-orange-500" strokeWidth={1.75} />
                <h3 className="mt-6 font-display text-xl md:text-2xl font-bold uppercase tracking-tight text-white">
                  {a.title}
                </h3>
                <p className="mt-3 text-sm md:text-base text-neutral-400">{a.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
